import { render } from "./NTag.vue?vue&type=template&id=f4cf7016&ts=true"
import script from "./NTag.vue?vue&type=script&lang=ts"
export * from "./NTag.vue?vue&type=script&lang=ts"

import "./NTag.vue?vue&type=style&index=0&id=f4cf7016&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__